import authService from '../auth/authService';

export default {
  install(Vue) {
    Vue.prototype.$auth = authService;

    Vue.mixin({
      
      created() {
        if (this.handleLoginEvent) {
          authService.addListener('loginEvent', this.handleLoginEvent);
        }
      },

      destroyed() {
        if (this.handleLoginEvent) {
          authService.removeListener('loginEvent', this.handleLoginEvent);
        }
      },

      // methods: {
      //   highestRole: function (roles){
      //     let ordered = {};
      //     ordered = roles.sort(function(a, b) {
      //       return (a.id) - (b.id);
      //     });
      //     return ordered[0].name;
      //   }
      // }

    });
  }
};